import { render } from "./TheMyCollectionHeader.vue?vue&type=template&id=34e7a903&scoped=true&ts=true"
import script from "./TheMyCollectionHeader.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionHeader.vue?vue&type=script&lang=ts"

import "./TheMyCollectionHeader.vue?vue&type=style&index=0&id=34e7a903&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e7a903"]])

export default __exports__